import { classNames } from '../utilities';

type Props = {
  onClick?: () => void;
  height?: number;
  width?: number;
  fill?: string;
};

export const HelperIcon = ({
  onClick,
  height = 24,
  width = 21,
  fill = '#00d091',
}: Props) => {
  return (
    <svg
      className={classNames(
        'helpercursor-pointer',
        onClick ? 'cursor-pointer' : ''
      )}
      onClick={onClick ? onClick : undefined}
      width={width}
      height={height}
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3833 17.1429C10.7917 17.1429 11.1368 17.0048 11.4188 16.7286C11.7007 16.4524 11.8417 16.1143 11.8417 15.7143C11.8417 15.3143 11.7007 14.9762 11.4188 14.7C11.1368 14.4238 10.7917 14.2857 10.3833 14.2857C9.975 14.2857 9.62986 14.4238 9.34792 14.7C9.06597 14.9762 8.925 15.3143 8.925 15.7143C8.925 16.1143 9.06597 16.4524 9.34792 16.7286C9.62986 17.0048 9.975 17.1429 10.3833 17.1429ZM9.33333 12.7429H11.4917C11.4917 12.419 11.5063 12.1429 11.5354 11.9143C11.5646 11.6857 11.6278 11.4667 11.725 11.2571C11.8222 11.0476 11.9438 10.8524 12.0896 10.6714C12.2354 10.4905 12.4444 10.2667 12.7167 10C13.3972 9.33333 13.8785 8.77619 14.1604 8.32857C14.4424 7.88095 14.5833 7.37143 14.5833 6.8C14.5833 5.79048 14.2333 4.97619 13.5333 4.35714C12.8333 3.7381 11.8903 3.42857 10.7042 3.42857C9.63472 3.42857 8.72569 3.68571 7.97708 4.2C7.22847 4.71429 6.70833 5.42857 6.41667 6.34286L8.34167 7.08571C8.47778 6.57143 8.75 6.15714 9.15833 5.84286C9.56667 5.52857 10.0431 5.37143 10.5875 5.37143C11.1125 5.37143 11.55 5.50952 11.9 5.78571C12.25 6.0619 12.425 6.42857 12.425 6.88571C12.425 7.20952 12.3181 7.55238 12.1042 7.91429C11.8903 8.27619 11.5306 8.67619 11.025 9.11429C10.6944 9.38095 10.4271 9.64286 10.2229 9.9C10.0188 10.1571 9.84861 10.4286 9.7125 10.7143C9.57639 11 9.47917 11.3 9.42083 11.6143C9.3625 11.9286 9.33333 12.3048 9.33333 12.7429ZM10.5 24L7 20.5714H2.33333C1.69167 20.5714 1.14236 20.3476 0.685417 19.9C0.228472 19.4524 0 18.9143 0 18.2857V2.28571C0 1.65714 0.228472 1.11905 0.685417 0.671429C1.14236 0.22381 1.69167 0 2.33333 0H18.6667C19.3083 0 19.8576 0.22381 20.3146 0.671429C20.7715 1.11905 21 1.65714 21 2.28571V18.2857C21 18.9143 20.7715 19.4524 20.3146 19.9C19.8576 20.3476 19.3083 20.5714 18.6667 20.5714H14L10.5 24ZM2.33333 18.2857H7.93333L10.5 20.8L13.0667 18.2857H18.6667V2.28571H2.33333V18.2857Z"
        fill={fill}
      />
    </svg>
  );
};
